import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

const getAlignRightDistance = (track, container) => {
	const currentX = gsap.getProperty(track, 'x') || 0
	const trackRight = track.getBoundingClientRect().right - currentX
	const containerRight = container.getBoundingClientRect().right

	return Math.max(0, trackRight - containerRight)
}

export const initDiagram = () => {
	const diagrams = document.querySelectorAll('[data-diagram]')

	if (!diagrams.length) return

	diagrams.forEach((diagram) => {
		const diagramHolder = diagram.querySelector('[data-diagram-holder]')
		const diagramTrack = diagram.querySelector('[data-diagram-track]')
		const diagramProgress = diagram.querySelector('[data-diagram-progress]')
		const diagramProgressBar = diagram.querySelector('[data-diagram-progress-bar]')
		const speedMultiplier = 1.1
		const scrub = 0.6

		if (!diagramTrack) return

		const tl = gsap.timeline({
			scrollTrigger: {
				trigger: diagramHolder,
				start: 'center center',
				end: () => `+=${getAlignRightDistance(diagramTrack, diagramHolder) * speedMultiplier}`,
				pin: true,
				scrub: scrub,
				invalidateOnRefresh: true,
			}
		})

		tl.to(diagramTrack, {
			x: 0,
			ease: 'none',
			duration: 0.25
		})

		tl.to(diagramTrack, {
			x: () => -getAlignRightDistance(diagramTrack, diagramHolder),
			ease: 'none',
			duration: 2
		})

		tl.fromTo(diagramTrack, {
			y: 0
		}, {
			y: 0,
			ease: 'none',
			duration: 0.25
		})

		const progressTl = gsap.timeline({
			scrollTrigger: {
				trigger: diagramHolder,
				start: 'center center',
				end: () => `+=${getAlignRightDistance(diagramTrack, diagramHolder) * speedMultiplier}`,
				scrub: scrub,
				invalidateOnRefresh: true,
				onEnter: () => diagramProgress.classList.add('is-visible'),
				onEnterBack: () => diagramProgress.classList.add('is-visible'),
				onLeave: () => diagramProgress.classList.remove('is-visible'),
				onLeaveBack: () => diagramProgress.classList.remove('is-visible'),
			}
		})


		progressTl.fromTo(diagramProgressBar, {
			width: '0%'
		}, {
			width: '100%',
			ease: 'none'
		})

	})
}